import React from 'react';
import { useData } from '../../lib/DataContext.jsx';

/**
 * ProjectCode — clickable primitive that opens the BeneficiaryModal.
 * Usage: <ProjectCode code="P0314" />
 */
export function ProjectCode({ code, children, subtle, style }) {
  const { setOpenProject } = useData();
  if (!code) return null;
  return (
    <button
      onClick={(e) => { e.stopPropagation(); setOpenProject(code); }}
      data-testid={`project-code-${code}`}
      className="tabular"
      style={{
        background: 'transparent',
        color: subtle ? 'inherit' : 'var(--primary)',
        border: 0,
        padding: 0,
        cursor: 'pointer',
        font: 'inherit',
        fontWeight: 700,
        textDecoration: subtle ? 'none' : 'underline dotted',
        textUnderlineOffset: 3,
        ...style,
      }}
      title={`Show beneficiary breakdown for ${code}`}
    >
      {children || code}
    </button>
  );
}
